<style coped>
.bg-primary {
  background-color: #1a3665 !important;
}
/* div#swal2-content {
  font-size: 16px;
  padding-top: 15px;
  padding-bottom: 15px;
} */
input.text-uppercase {
  text-transform: uppercase;
}

::-webkit-input-placeholder {
  text-transform: none;
}

:-moz-placeholder {
  text-transform: none;
}

::-moz-placeholder {
  text-transform: none;
}

:-ms-input-placeholder {
  text-transform: none;
}
</style>

<template>
  <CCard>
    <CCardHeader class="bg-primary text-white d-flex align-items-center font-weight-bold">
      Master Mata Uji
      <template v-if="role_status && role_status.status_create">
        <CButton
          color="success"
          style="float:right"
          class="btn-md ml-auto button-md-block px-3"
          @click="openTambahModal"
        >Tambah</CButton>
      </template>
      <template v-else>
          <CButton color="secondary" 
          style="float:right"
          class="btn-md ml-auto button-md-block px-3" 
          disabled>Tambah</CButton>
      </template>
    </CCardHeader>
    <!-- Data Sertifikasi -->
    <CCardBody>
      <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
          />
          <br />
        </CCol>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable :items="items" :fields="fields" hover sorter>
            <template #no="{ index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #kodeMataUji="{item}">
              <td class="py-2 font-weight-bold text-uppercase">{{ item.kodeMataUji ? item.kodeMataUji : '-' }}</td>
            </template>
            <template #namaMataUji="{item}">
              <td class="py-2">{{ item.namaMataUji ? item.namaMataUji : '-' }}</td>
            </template>
            <template #nilaiMinimum="{item}">
              <td
                class="py-2 font-weight-bold text-center"
              >{{ item.nilaiMinimum ? item.nilaiMinimum : '-' }}</td>
            </template>
            <template #jumlahMataKuliah="{item}">
              <td
                class="py-2 font-weight-bold text-center"
              >{{ item.jumlahMataKuliah ? item.jumlahMataKuliah : '-' }}</td>
            </template>
            <template #status="{item}">
              <td class="py-2 text-center">
                 <p  v-if="item.status == 1" class="text-success font-weight-bold"> Aktif</p>
                <p  v-else class="text-danger font-weight-bold"> Tidak Aktif</p>
              </td>
            </template>
            <template #statusGrader="{item}">
              <td class="py-2 text-center">
                 <p  v-if="item.statusGrader == 1" class="text-success font-weight-bold"> Aktif</p>
                <p  v-else class="text-danger font-weight-bold"> Tidak Aktif</p>
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 text-center d-flex align-items-center">
                <template v-if="role_status && role_status.status_update">
                    <CButton v-c-tooltip="'Ubah'" color="info" square size="sm" @click="updateData(item, index)">
                    <font-awesome-icon icon="edit" />
                    </CButton>&nbsp;&nbsp;
                </template>
                <template v-else>
                    <CButton v-c-tooltip="'Ubah'" color="secondary" square size="sm" disabled>
                    <font-awesome-icon icon="edit" />
                    </CButton>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                    <CButton v-c-tooltip="'Hapus'" color="danger" square size="sm" @click="deleteData(item, index)">
                    <font-awesome-icon icon="trash" />
                    </CButton>
                </template>
                <template v-else>
                    <CButton v-c-tooltip="'Hapus'" color="secondary" square size="sm" disabled>
                    <font-awesome-icon icon="trash" />
                    </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        size="lg"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <div class="form-row col-12">
              <div class="form-group col-12" >
                <label for class="font-weight-bold ">Kode Mata Uji</label>
                <TextField
                  myclass="form-control text-uppercase"
                  id="kodematauji"
                  maxlength="500"
                  
                  :required="false"
                  :readonly="actionPost == 'update'"
                  characterAllow="qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890-"
                  v-model="formData.kodeMataUji"
                  placeholder="Masukkan Kode Mata Uji"
                  :class="{
                    'is-invalid': $v.formData.kodeMataUji.$error, 
                  }"
                />
              </div>
            </div>
            <div class="form-row col-12">
              <div class="form-group col-12">
                <label for class="font-weight-bold">Nama Mata Uji</label>
                <TextField
                  myclass="form-control"
                  id="namamatauji"
                  maxlength="500"
                  :required="true"
                  characterAllow="qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890- ,."
                  v-model="formData.namaMataUji"
                  placeholder="Masukkan Nama Mata Uji"
                  :class="{
                    'is-invalid': $v.formData.namaMataUji.$error, 
                  }"
                />
              </div>
            </div>
            <div class="form-row col-12">
              <div class="form-group col-12">
                <label for class="font-weight-bold">Batas Nilai</label>                
                <TextField
                  myclass="form-control"
                  id="nilaimatauji"
                  maxlength="5"
                  :required="true"
                  characterAllow="1234567890."
                  v-model="formData.nilaiMinimum" 
                  placeholder="Masukkan Batas Nilai"
                  :class="{
                    'is-invalid': $v.formData.nilaiMinimum.$error, 
                  }"
                />
              </div>
            </div>
            <div class="form-row col-12">
              <div class="form-group col-12">
                <label for class="font-weight-bold">Keterangan</label>
                <textarea 
                  class="form-control" 
                  name id rows="3" 
                  v-model="formData.keterangan" 
                  placeholder="Masukkan keterangan"></textarea>
              </div>
            </div>
            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status Mata Kuliah</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadioMataKuliah"
                    value="1"
                    v-model="formData.statusMataKuliah"
                    id="mataKuliahAktif"
                    checked
                  />
                  <label class="custom-control-label" for="mataKuliahAktif">Ya</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadioMataKuliah"
                    value="0"
                    id="mataKuliahNonAktif"
                    v-model="formData.statusMataKuliah"
                  />
                  <label class="custom-control-label" for="mataKuliahNonAktif">Tidak</label>
                </div>
              </div>
            </CCol> 
            <div class="form-row col-12" v-for="(value,k) in formData.mataKuliah" :key="k" v-show="formData.statusMataKuliah == '1'" >
              <div class="form-group col-11" >
                  <label for class="font-weight-bold">Mata Kuliah</label>                
                  <multiselect
                    label="namaMataKuliah"
                    placeholder="Pilih Mata Kuliah"
                    v-model="value.modelMataKuliah"
                    :options="mataKuliahSelect"
                    :class="{
                      'has-error': $v.formData.mataKuliah.$each[k].idMataKuliah.$error
                    }"
                    @input="(value) => selectMataKuliah(value, k)"
                  ></multiselect>
              </div>
              <div class="col-1 d-flex align-items-center mt-2">
                <div
                  class="btn btn-sm btn-success ml-2"
                  @click="addMataKuliah(k)"
                  v-show="k == formData.mataKuliah.length-1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2"
                  @click="deleteMataKuliah(k)"
                  v-show="k || ( !k && formData.mataKuliah.length > 1)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status Grader</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadioGrader"
                    value="1"
                    v-model="formData.statusGrader"
                    id="aktifGrader"
                    checked
                  />
                  <label class="custom-control-label" for="aktifGrader">Ya</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadioGrader"
                    value="0"
                    id="tidak_aktifGrader"
                    v-model="formData.statusGrader"
                  />
                  <label class="custom-control-label" for="tidak_aktifGrader">Tidak</label>
                </div>
              </div>
            </CCol>
            <div class="form-row col-12" v-show="formData.statusGrader == '1'">
              <div class="form-group col-6" >
                <label for="mata_uji" class="font-weight-bold" >Grader 1</label>
                <multiselect
                  label="name"
                  placeholder="Pilih Grader"
                  v-model="formData.modelGraderSatu"
                  @input="(value) => pilihGraderSatu(value,k)"
                  :options="option_grader"
                  :class="{
                    'has-error': $v.formData.modelGraderSatu.$error || $v.formData.graderSatu.$error
                  }"
                ></multiselect>
              </div>
              <div class="form-group col-6" >
                <label for="mata_uji" class="font-weight-bold">Grader 2</label>
                <multiselect
                  label="name"
                  placeholder="Pilih Grader"
                  v-model="formData.modelGraderDua"
                  @input="(value) => pilihGraderDua(value,k)"
                  :options="option_grader"
                  :class="{
                    'has-error': $v.formData.modelGraderDua.$error || $v.formData.graderDua.$error
                  }"
                ></multiselect>
              </div>
            </div>
            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status Mata Uji</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    value="1"
                    v-model="formData.status"
                    id="aktif"
                    checked
                  />
                  <label class="custom-control-label" for="aktif">Aktif</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    value="0"
                    id="tidak_aktif"
                    v-model="formData.status"
                  />
                  <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                </div>
              </div>
              <span v-if="$v.formData.status.$error" class="text-danger">
                *Mohon pilih status
              </span>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{title}}</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- end data kota/kab -->
  </CCard>
</template>
<script>
import { required, requiredIf } from 'vuelidate/lib/validators'

import MasterMataUjiService from '@/services/sertifikasi/mata-uji.service';
import UserGraderService from "@/services/sertifikasi/user-grader.service"
import MataKuliahService from "@/services/datamaster/mata-kuliah.service";

import { AlertUtils } from '@/mixins/AlertUtils';
import { Pagination } from '@/mixins/Pagination';
import { MataUji } from "@/mixins/master/MataUji";
import TextField from '@/components/formcomponent/TextField';

const fields = [
  { key: 'no', _style: 'width: 8%' },
  {
    key: "kodeMataUji",
    label: 'Kode Mata Uji',
    _style: 'width: 15%'
  },
  {
    key: 'namaMataUji',
    label: 'Nama Mata Uji',
    _style: 'width: 18%'
  },
  {
    key: 'jumlahMataKuliah',
    label: 'Jumlah Mata Kuliah',
    _style: 'width: 18%'
  },
  {
    key: 'nilaiMinimum',
    label: 'Batas Nilai',
    _style: 'width: 35%; text-align: center'
  },
  { key: 'status', _style: 'text-align: center' },
  { key: 'statusGrader', _style: 'text-align: center' },
  { key: 'aksi', _style: 'width:12%; text-align: center' }
];

export default {  
  mixins: [
    AlertUtils, 
    Pagination,
    MataUji
  ],
  data() {
    return {
      actionPost: '',
      option_grader : [],
      mataKuliahSelect : [],
      mataKuliah: '',
      formData: {
        kodeMataUji: '',
        namaMataUji: '',
        mataKuliah: [
          {
            idDatMataKuliah: '',
            modelMataKuliah : [],
            idMataKuliah: ''
          }
        ],
        nilaiMinimum: '',
        keterangan: '',
        graderSatu : '',
        graderDua : '',
        modelMataKuliah : [],
        modelGraderSatu : [],
        modelGraderDua : [],
        status: '',
        statusMataKuliah: '',
        statusGrader: '',
        idMasterMataUji: '',
        role_status: null, 
      },
      fields,
      title: '',
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: 'col-3', input: 'col-9' },

      collapseDuration: 0,
      content: [],
      loading: true
    };
  },

   validations: {
    formData: {      
      kodeMataUji: { required },
      namaMataUji: { required },
      nilaiMinimum: { required },
      status: { required },
      modelGraderDua: { 
        required: requiredIf(function () {
          return this.formData.statusGrader === '1';
        })
      },
      modelGraderSatu: {
        required: requiredIf(function () {
          return this.formData.statusGrader === '1';
        })
      },
      mataKuliah : {
        $each: {
          idMataKuliah : { 
            required : requiredIf(function() {
              return this.formData.statusMataKuliah === '1'
            }) 
          }
        }
      },
      graderDua: {
        required: requiredIf(function () {
          return this.formData.statusGrader === '1';
        })
      },
      graderSatu: {
        required: requiredIf(function () {
          return this.formData.statusGrader === '1';
        })
      },     
    }
  },

  components : {
    TextField
  },
  mounted() {
    this.getData('0', this.pageSize, this.search);
    this.getAllMataUji();
    this.getDataUserGrader();
    this.getMataKuliahSelect();
    this.roleData();
  },

  methods: {
    roleData()
    {
        var user = JSON.parse(localStorage.getItem('user'));
        var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
        this.role_status = data;
    },
    getMataKuliahSelect(){
      MataKuliahService.getMataKuliahSelect()
      .then(response => {
        this.mataKuliahSelect = response.data.data
      }).catch(error => {
        // comment console console.log(error);
      })
    },
    selectMataKuliah(value,k) {
      if(value) {
        var data = value.idMataKuliah;
        var status_invalid_form = 0;


        for ( let index = 0;  index < this.formData.mataKuliah.length; index++) {
          var idMataKuliah = this.formData.mataKuliah[index].idMataKuliah;
          var idSelectMataKuliah = data;

          if (idMataKuliah == idSelectMataKuliah) {
              status_invalid_form += 1;
          }
        }

        if(status_invalid_form > 0) {
          this.alertError("Tidak Boleh Ada Mata Kuliah Yang Sama");
          this.formData.mataKuliah[k].idMataKuliah = ''
          this.formData.mataKuliah[k].modelMataKuliah = []
          return false;
        } else {
          
          this.formData.mataKuliah[k].idMataKuliah = value.idMataKuliah
        }
      } else {
        this.formData.mataKuliah.idMataKuliah = ''
        this.formData.mataKuliah.modelMataKuliah = []
      }
    },

    addMataKuliah(index) {
      var data =  this.formData.mataKuliah;
      var katalog = [];
  
      this.formData.mataKuliah.push({
        idDatMataKuliah: '',
        modelMataKuliah : [],
        idMataKuliah: ''
      });

    },

    removeMataKuliah(index) {
      this.formData.mataKuliah.splice(index, 1);
    },

    getDataUserGrader(){
      UserGraderService.getUserGrader(0,1000000000,'default')
      .then(response => {
        this.option_grader = response.data.data.content
      }).catch(error => {
        // comment console console.log(error);
      })
    },

    pilihGraderDua(value, k) {
      if(this.formData.graderSatu ==value.id) {
        this.formData.modelGraderDua = []
        this.alertError("Tidak Boleh Ada Grader Yang Sama");
        this.formData.graderDua = ""
        return false;
      } else {
        this.formData.graderDua = value.id
      }
    },

    pilihGraderSatu(value, k) {
      if(value.id == this.formData.graderDua) {
        this.formData.modelGraderSatu = []
        this.alertError("Tidak Boleh Ada Grader Yang Sama");
        this.formData.graderSatu = ""
        return false;
      } else {
        this.formData.graderSatu = value.id
      }
    },

    pageChange() {
      this.getData(currentPage);
    },

    deleteData(item, index) {
      this.formData = item;
      var vm = this;
      this.$swal
        .fire({
          title: 'Peringatan!',
          text: 'Apakah anda yakin ingin menghapus data ini ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            MasterMataUjiService.deleteMataUji(this.formData)
              .then(response => {
                // comment console console.log(response);
                vm.alertDeleteSuccess();
                vm.getData('0', this.pageSize, this.search);
              })
              .catch(error => {
                vm.alertError(error.response.data.message);
                // comment console console.log(error);
              });
            Toast.fire({
              icon: 'cancel',
              title: 'Data Berhasil Dihapus'
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              'Cancelled',
              'Your imaginary file is safe :)',
              'error'
            );
          }
        });
    },

    deleteMataKuliah(index) {
      var vm = this;
      this.$swal
        .fire({
          title: 'Peringatan!',
          text: 'Apakah anda yakin ingin menghapus data ini ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            this.removeMataKuliah(index);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              'Cancelled', 
              'Your imaginary file is safe :)',
              'error'
            );
          }
        });
    },

    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      MasterMataUjiService.getMataUji(currentPage, pageSize, filter)
        .then(response => {
          // comment console console.log(response.data.data.content);
          vm.items = response.data.data.content;
          // // comment console console.log('ini data MataUji')
          // // comment console console.log(items);
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;

          loader.hide();
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    createData() {
      this.myModal = true;
      this.formData = {
        kodeMataUji: '',
        namaMataUji: '',
        mataKuliah: [
          {
            idDatMataKuliah: '',
            modelMataKuliah : [],
            idMataKuliah: ''
          }
        ],
        nilaiMinimum: '',
        keterangan: '',
        graderSatu : '',
        graderDua : '',
        modelMataKuliah : [],
        modelGraderSatu : [],
        modelGraderDua : [],
        status: '',
        statusMataKuliah: '',
        statusGrader: '',
        idMasterMataUji: ''
      };
      this.actionPost = 'insert';
      this.title = 'Tambah';
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      if(item.mataKuliah.length <= 0) {
        this.formData.mataKuliah=  [
            {
              idDatMataKuliah: '',
              modelMataKuliah : [],
              idMataKuliah: ''
            }
          ];
      }
      this.formData.statusMataKuliah= item.statusMataKuliah;
      this.actionPost = 'update';
      this.title = 'Edit';
    },

    postData() {
      this.$v.$touch();
      if(this.$v.$invalid) {        
        return;
      } else {
        if (this.actionPost == 'insert') {
          this.insertData(this.formData);
        } else if (this.actionPost == 'update') {
          this.putData();
        }
      }      
    },

    insertData(formData) {
      // this.errors.clear();
      // comment console console.log(formData);
      // comment console console.log('posat');
      var vm = this;
      MasterMataUjiService.postMataUji(formData)
        .then(response => {
          vm.myModal = false;
          vm.alertSuccess();
          vm.getData(0, 10, 'default');
        })
        .catch(error => {
          // comment console console.log(error);
          vm.alertError(error.response.data.message);
        });
    },

    putData() {
      // this.errors.clear();
      // comment console console.log('put');
      // comment console console.log(this.formData);
      var vm = this;
      MasterMataUjiService.putMataUji(this.formData)
        .then(response => {
          vm.myModal = false;

          vm.alertEditSuccess();

          vm.getData('0', this.pageSize, this.search);
        })
        .catch(error => {
          // comment console console.log(error);

          vm.alertError(error.response.data.message);
        });
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>